// extracted by mini-css-extract-plugin
export var chevron = "_fo-4";
export var chevronExpanded = "_fo-5";
export var row = "_fo-0";
export var rowBody = "_fo-6";
export var rowDescription = "_fo-7";
export var rowHeader = "_fo-1";
export var rowTitle = "_fo-2";
export var rowTitleComplete = "_fo-3";